var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.empresa)?_c('FichaEmpresa',{attrs:{"empresa":_vm.empresa,"onBack":function () { return _vm.$router.push('/empresas'); }}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }